<template>
  <div>
    <div class="container-fluid component">
      <help portal="mygea" class="pull-right" />
      <p class="h4 heading">SFGTA Renew/Modify Agreement</p>
      <p>
        Attention: Please note that this information is required in order to prepare an updated agreement and prevent
        any interruption of your support. Based on your inputs, an updated agreement document will be created and sent
        to you for your signature.
      </p>
      <accordion ref="accordian" type="default" one-at-atime>
        <panel id="sfgtaGeneralInfo" header="General Company Information" is-open>
          <sfgta-general-company-information @submitSFGTA="submitForm" />
        </panel>
      </accordion>
    </div>
    <!-- loader -->
    <spinner
      ref="spinner"
      v-model="showSpinner"
      fixed
      size="lg"
      text="Please be patient we are processing your request. Please do not hit the back button / resubmit or a duplicate request may be created."
    />
    <!-- Notification Failure -->
    <modal v-model="registrationFailed" effect="fade" width="40%">
      <div slot="modal-header" class="modal-header"><strong class="modal-title">Message</strong></div>
      <div>
        <span class="fa fa-exclamation text-warning fa-lg" />
        Your request could not be submitted due to an intermittent connection issue! Please try submitting your request
        again after sometime.
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button id="forgotUser" type="button" class="btn btn-sm btn-primary" @click="regFailed()">
          OK
        </button>
      </div>
    </modal>
  </div>
</template>
<script>
import accordion from "build-ui-x/src/Accordion";
import { mapState } from "vuex";
import panel from "build-ui-x/src/Panel";
import sfgtaGeneralCompanyInformation from "@/mycfm/components/new-company/SfgtaGeneralCompanyInformation";
import help from "@/mycfm/components/HelpInfo";
import { submitSfgtaRequest } from "@/services/endpointsService";
import spinner from "build-ui-x/src/Spinner";
import modal from "build-ui-x/src/Modal";

export default {
  components: {
    accordion,
    panel,
    sfgtaGeneralCompanyInformation,
    help,
    spinner,
    modal
  },
  data() {
    return {
      showSpinner: false,
      registrationFailed: false
    };
  },
  computed: {
    ...mapState("modifyAgreement", ["modifyAgreement"])
  },
  methods: {
    regFailed() {
      this.registrationFailed = false;
      this.$router.push("/sfgta-agreement");
      window.location.reload();
    },
    submitForm(recaptchaData) {
      this.showSpinner = true;
      let formData = new FormData();
      let data = this.modifyAgreement;
      delete data.engSrvceScopeChgFlg;
      delete data.engSrvceScopeDesc;
      delete data.addtlProductReqdFlg;
      delete data.addtlProductDesc;
      formData.append("sfgtaRequestString", JSON.stringify(data));
      // append files to form
      let filesStore = this.$store.state["files"].files;
      for (let file in filesStore) {
        formData.append(file, filesStore[file]);
      }
      submitSfgtaRequest(formData, recaptchaData)
        .then(data => {
          if (data.submitSuccessful) {
            this.$store.dispatch("product/setReferenceNumber", data.referenceNumber);
            this.$router.push("/sfgtaSuccess");
          }
        })
        .catch(() => {
          this.registrationFailed = true;
        })
        .finally(() => {
          // hide spinner
          this.showSpinner = false;
        });
    }
  }
};
</script>
<style>
#sfgtaGeneralInfo > .accordion-toggle {
  pointer-events: none;
}
</style>
